import {
  ShiftChangeRequestApprovalStatus,
  ShiftChangeRequestColleagueApprovalStatus,
  ShiftChangeRequestDetailedStatus,
  ShiftChangeRequestFragmentFragment,
} from '../../../__generated__/graphql';

export type ReceivedShiftChangeRequestTableItem = {
  id: string;
  name: string;
  shiftId: string | null;
  shiftTitle: string;
  shiftStartDate: string;
  shiftEndDate: string;
  requestedAt: string;
  requestReason: string | null;
  requestedByEmployee: {
    id: string;
    name: string;
  } | null;
  status: ShiftChangeRequestApprovalStatus;
  statusDetailed: ShiftChangeRequestDetailedStatus | null;
  colleagueApprovalStatus: ShiftChangeRequestColleagueApprovalStatus | null;
  actions: React.ReactNode;
};

export const mapReceivedShiftChangeRequests = (
  requests: readonly ShiftChangeRequestFragmentFragment[],
): ReceivedShiftChangeRequestTableItem[] => {
  return requests.map((request) => ({
    id: request.Id,
    name: request.Id,
    shiftId: request.shift?.Id || null,
    shiftTitle: request.shift?.flair__Title__c || '',
    shiftStartDate: request.shift?.flair__Start_Datetime__c || '',
    shiftEndDate: request.shift?.flair__End_Datetime__c || '',
    requestedAt: request.flair__Requested_At__c || '',
    requestReason: request.flair__Change_Reason__c || null,
    requestedByEmployee: request.requestedByEmployee
      ? {
          id: request.requestedByEmployee.Id,
          name: request.requestedByEmployee.Name,
        }
      : null,
    status: request.flair__Approval_Status__c,
    statusDetailed: request.flair__Approval_Status_Detailed__c || null,
    colleagueApprovalStatus:
      request.flair__Colleague_Approval_Status__c || null,
    actions: null,
  }));
};
